import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiheaderService } from './apiheader.service';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { throwError, of } from 'rxjs';
import { URLPaths } from '../utilities/urlPaths.config';


@Injectable({
  providedIn: 'root'
})
export class SustainabilityFlagService {
  private baseUrl = URLPaths.URL_SUSTAINABILITY_FLAG;

  constructor(private http: HttpClient) {}

  postFlag(employeeId: string, month: string, year: string, timestamp: string) {
     const payload = {
    employee_id: employeeId,
    month: month,
    year: year,
    flag: true,
    timestamp:timestamp,
  };
    return this.http.post(
    this.baseUrl,
    payload,
    {headers: ApiheaderService.getHeaders() }
  );
  }
  getSustainabilityFlagDetailsBatch(employeeId: string, yearMonths: string[]): Observable<Array<{ flagExists: boolean; flag_hit: number; month: string; year: string }>> {
    const headers = ApiheaderService.getHeaders();
    let params = new HttpParams().set('employee_id', employeeId);
    yearMonths.forEach(ym => {
      params = params.append('yearMonths', ym);
    });

    return this.http.get<any>(this.baseUrl, { params, headers }).pipe(
      map(response => {
        if (Array.isArray(response)) {
          return response.map(item => {
            const flag_hit = item?.flag_hit !== undefined ? Number(item.flag_hit) : (item?.flagExists ? 1 : 0);
            return {
              flagExists: flag_hit === 1,
              flag_hit: flag_hit,
              month: item?.month !== undefined ? String(item.month) : '',
              year: item?.year !== undefined ? String(item.year) : ''
            };
          });
        }
        return [];
      }),
      catchError(error => {
        console.error('Error fetching sustainability flag batch data:', error);
        return of([]);
      })
    );
  }

  getSustainabilityFlagDetails(employeeId: string, month: string, year: string): Observable<{ flagExists: boolean; flag_hit: number; month: string; year: string }> {
    const headers = ApiheaderService.getHeaders();
    const params = new HttpParams()
      .set('employee_id', employeeId)
      .set('month', month)
      .set('year', year);

    return this.http.get<any>(this.baseUrl, { params, headers }).pipe(
      map(response => {
        const flag_hit = response?.flag_hit !== undefined ? Number(response.flag_hit) : (response?.flagExists ? 1 : 0);
        return {
          flagExists: flag_hit === 1,
          flag_hit: flag_hit,
          month: response?.month !== undefined ? String(response.month) : month,
          year: response?.year !== undefined ? String(response.year) : year
        };
      }),
      catchError(error => {
        console.error('Error fetching sustainability data:', error);
        return of({ flagExists: false, flag_hit: 0, month, year });
      })
    );
  }

  getSustainabilityFlag(employeeId: string, month: string, year: string): Observable<boolean> {
    return this.getSustainabilityFlagDetails(employeeId, month, year).pipe(
      map(res => res.flag_hit === 1)
    );
  }

  deleteFlag(employeeId: string, month: string | number, year: string | number): Observable<any> {
    const headers = ApiheaderService.getHeaders();
    const monthStr = month != null ? (isNaN(Number(month)) ? String(month) : String(month).padStart(2, '0')) : '';
    const yearStr = year != null ? String(year) : '';
    const params = new HttpParams()
      .set('employee_id', employeeId || '')
      .set('month', monthStr)
      .set('year', yearStr);

    return this.http.delete(this.baseUrl, { params, headers });
  }
}
